import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FieldReportingService } from '@modules/field-reporting/services/field-reporting/field-reporting.service';
import { UserService } from '@shared/services/user/user.service';
import { catchError, defer, forkJoin, iif, Observable, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { WorkOrderService } from '@modules/planner/services/workorder/work-order.service';
import { WorkOrder, WorkOrderSearch } from '@shared/models/work-order';
import { PlannerProjectService } from '@modules/planner/services/planner-project/planner-project.service';
import { RowNumber } from '@modules/planner/components/weekly-planning-map/weekly-planning-map.component';
import { ToastService } from "@shared/services/toast/toast.service";
import {
  BaseReport,
  ROUTE_PLANNER_POLYLINE_COLOR,
  ROUTE_PLANNER_POLYLINE_SHAPE_OPTIONS,
  RouteNote,
  RoutePlanningBase,
  RoutePlanningRoute,
} from '@shared/models/route-planning';
import { Report } from '@shared/models/report';
import { RoutePlanningService } from '@modules/planner/services/route-planning/route-planning.service';
import { CustomerSettingsService } from "@shared/services/customerSettings/customer-settings.service";
import { CustomerIds, CustomerSettingsComponents } from "@shared/models/customer-settings";
import { finalize } from "rxjs/operators";
import { MapUtils } from "@shared/services/mapUtils/map-utils.service";
import { DateUtils } from "@shared/services/dateUtils/date-utils.service";
import { MultiSelectSearchTypes } from "@shared/models/multi-select-search";
import { Status } from "@shared/models/status";
import { StorageKeys, StorageService } from "@shared/services/storage/storage.service";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Modal } from 'bootstrap';
import { BasemapService } from '@shared/services/basemap/basemap.service';

declare const L: any;

type RouteNoteModalType = 'CREATE' | 'EDIT' | 'DELETE';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('routeNotesModal') routeNotesModalElement!: ElementRef;
  private routeNotesModalInstance!: Modal;
  public routeNoteMode: RouteNoteModalType = 'CREATE';
  public routeNoteText = '';
  public selectedRouteNote: RouteNote | null = null;

  componentDestroyed$: Subject<boolean> = new Subject()

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private fieldReporting: FieldReportingService,
    private translateService: TranslateService,
    private workOrderService: WorkOrderService,
    private plannerProjectService: PlannerProjectService,
    private changeDetectorRef: ChangeDetectorRef,
    private toastService: ToastService,
    private router: Router,
    private customerSettingsService: CustomerSettingsService,
    private routePlanningService: RoutePlanningService,
    private storageService: StorageService,
    private basemapService: BasemapService,
    private modalService: NgbModal
  ) { }

  workOrdersLoading = true;
  userid: any;
  customerId: any;
  lang = '';
  customerIds = CustomerIds;
  currentProject: any;
  projects = Array();
  workerteams = Array();
  workerteamStatuses: Set<{ workerteamId: number, statusId, statusName: string }> = new Set();
  selectedWorkerteamStatusId: number | null = null;
  filterByStatuses = false;
  currentWorkerteam;
  tab = 0;
  currentUser;
  workOrderArray = Array()
  displayedWorkOrders = Array()
  // allOrders = Array()
  mustDoForTodayOrders = Array()
  doneOrders: WorkOrder[] = [];
  toDoCount = 0;
  doneCount = 0;
  freeLocationsCount = 0;
  tabTitle = ''
  topIcon = 0
  expandInventoryList = 'assets/icons/expand_more_gray_24dp.svg';
  showInventoryList = false;
  showDashboard = true;
  showSingleOrderDetail = false;
  workOrderId;
  runGetWorkOrder = false;
  typeArray = Array();
  lat: number | null = null
  lon: number | null = null

  map: any

  selectedWorkOrder: WorkOrder | null = null;
  selectedMarker: L.Marker | null = null;
  selectedColor = 'grey';
  selectedStatusId = 0;
  currentStatusId = 0;
  selectedWorkOrderSearch: WorkOrder | null = null;

  allWorkOrders: { [key: number]: WorkOrder } = {};
  allStatuses: any[] = [];
  allStatusesMultiFilter: any[] = [];
  currentProjectId;
  workOrderMarkers: Map<number, L.Marker> = new Map();
  locationMarker: any;
  workOrdersInCalendar: WorkOrder[] = [];

  BBOXFin = {
    sw: { lat: 60.17862810921057, lon: 23.963623690080446 },
    ne: { lat: 60.1847311378856, lon: 23.98555806249057 }
  };

  BBOXSwe = {
    sw: { lat: 60.039062, lon: 18.528942 },
    ne: { lat: 60.032419, lon: 18.560578 }
  }

  BBOXHallavahti = {
    sw: { lat: 62.1119, lon: 27.7792 },
    ne: { lat: 62.1360, lon: 27.8159 }
  }

  BBOXPowerlines = [
    {
      sw: { lat: 60.622487649289454, lon: 25.239608560223136 },
      ne: { lat: 60.66128552101471, lon: 25.321319375652823 },
    },
    {
      sw: { lat: 60.54043824, lon: 26.91716576 },
      ne: { lat: 60.63533448, lon: 27.12024913 },
    },
    {
      sw: { lat: 63.39622246, lon: 24.38132781 },
      ne: { lat: 63.47991312, lon: 24.46947613 },
    },
    {
      sw: { lat: 62.21347687, lon: 27.36549331 },
      ne: { lat: 62.84633027, lon: 27.68455918 },
    },
    {
      sw: { lat: 61.89350146, lon: 25.08969551 },
      ne: { lat: 62.28582688, lon: 25.13059834 },
    },
  ]

  centerLatitude = 0;
  centerLongitude = 0;
  rowNumbers;
  rowNumberMarkers;
  mapReady = new Subject<void>();
  type: number = 1;
  workOrders: WorkOrder[] = [];
  filteredWorkOrders: WorkOrder[] = [];
  highlightedMarkers: { id: number, color: string, weight: number }[] = [];
  resetSearch = false;
  powerLineWorkOrderMarkers: Map<number, L.Marker> = new Map();
  assignedOnlyChecked = false;
  reportedOnlyChecked = false;

  private basesMap = new Map<number, RoutePlanningBase>();
  private baseMarkers = new Map<number, L.Marker>();
  selectedBase: RoutePlanningBase | null = null;
  private baseReportsMap = new Map<number, BaseReport>();
  public baseReports: BaseReport[] = [];
  public selectedBaseReports: BaseReport[] = [];
  public selectedBaseReport: any = null;
  public showBaseReports = false;
  private searchPointer!: L.Marker | null;
  currentImg: any = null;
  loadingBaseReportImages = false;
  private routeNoteMarkers = new Map<number, L.Marker>();

  // Interruptions for workorders
  public selectedWorkOrderInterruptions: Report[] = [];
  public showInterruptions = false;

  get workerteamStatusesArray(): { workerteamId: number, statusId, statusName: string }[] {
    return Array.from(this.workerteamStatuses);
  }

  ngOnInit(): void {
    this.setUpCustomRectangleCanvas();
    this.setUpCustomTextMarkerCanvas();
    this.getCurrentProject();
    this.setTabTitle()
    // If we navigate from create report page use this to access current meter's information directly
    this.route.queryParams.subscribe(params => {
      if (params['meterId']) {
        this.workOrderId = params['meterId'];
        this.showDashboard = false;
        this.showSingleOrderDetail = true;
        this.runGetWorkOrder = true;
      }
    })
    this.mapReady.subscribe(() => {
      this.drawRowNumbersOnMap();
      this.getRoutes(this.currentProjectId);
      this.getBases(this.currentProjectId);
      if (this.customerId === CustomerIds.POWERLINES) {
        this.getRouteNotes(this.currentProjectId);
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true)
    this.componentDestroyed$.complete()
  }

  ngAfterViewInit() {
    // Ensure the map container is visible and has been rendered in the DOM
    setTimeout(() => this.initMap(), 0);
    this.routeNotesModalInstance = new Modal(this.routeNotesModalElement.nativeElement);
    this.setupDetailsContainerEventListeners();
  }

  private setupDetailsContainerEventListeners(): void {
    // Prevent map interaction when touching/dragging within the details panel
    setTimeout(() => {
      const detailsContainers = document.querySelectorAll('.workorder-details-container');
      detailsContainers.forEach((container: Element) => {
        // Prevent touch events from propagating to the map
        container.addEventListener('touchstart', (e) => {
          e.stopPropagation();
        }, { passive: true });

        container.addEventListener('touchmove', (e) => {
          e.stopPropagation();
        }, { passive: true });

        container.addEventListener('touchend', (e) => {
          e.stopPropagation();
        }, { passive: true });

        // Also handle mouse events for desktop drag prevention
        container.addEventListener('mousedown', (e) => {
          e.stopPropagation();
        });

        container.addEventListener('mousemove', (e) => {
          e.stopPropagation();
        });

        // Prevent mouse wheel from zooming the map when over the details panel
        container.addEventListener('wheel', (e) => {
          // Stop propagation to prevent the map from receiving the wheel event
          e.stopPropagation();
          // Let the browser handle scrolling naturally (don't preventDefault)
        }, { passive: true });
      });
    }, 1000);
  }

  private initStorage() {
    if (this.customerId !== CustomerIds.POWERLINES) return;

    this.assignedOnlyChecked = !!this.storageService.get(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_ASSIGNED_ONLY);
    if (this.assignedOnlyChecked) {
      const filteredWorkOrders = this.filterAssignedWorkOrders(this.workOrders);
      this.filterWorkOrders({ type: MultiSelectSearchTypes.POWERLINE, workOrders: filteredWorkOrders });
    }

    this.reportedOnlyChecked = !!this.storageService.get(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_REPORTED_ONLY);
    if (this.reportedOnlyChecked) {
      this.workerteamStatusOnChange(this.reportedOnlyChecked
        ? this.currentWorkerteam.values.status_id
        : null
      );
    }
  }

  addZoomListener() {
    this.map.on('zoomend', () => {
      const currentZoomLevel = this.map.getZoom();
      this.workOrderMarkers.forEach((marker: any) => {
        marker.options['size'] = MapUtils.getRelativeMarkerSize(marker.options.frame_size, currentZoomLevel, this.customerId)
      })
    });
  }



  /**
   * Get user info and set projects variable from it.
   * Set also workerteams correctly
   */
  getCurrentProject() {
    this.userService.getUserInfo()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        this.userid = data.id;
        this.customerId = data.customer_id;
        this.lang = data.language?.toLowerCase();

        if (this.centerLatitude == 0 || this.centerLongitude == 0) {
          if (this.getCenterCoordinates()) {
            this.centerMap()
          }
        }
        this.currentProjectId = data.current_project;
        this.getRowNumbers(this.currentProjectId).subscribe(
          { next: () => this.mapReady.next() }
        )
        this.projects = Array();
        // Loop through projects to add them to projects array. If
        // project id matches current project number set its name to current project variable
        for (let i = 0; i < Object.keys(data.projects).length; i++) {
          if (Object.keys(data.projects)[i] == data.current_project) this.currentProject = Object.values(data.projects)[i]
          if (Object.values(data.projects)[i] != this.currentProject) this.projects.push({ name: Object.values(data.projects)[i], id: Object.keys(data.projects)[i] })
        }
        // Loop through workers data and push workerteams to workerteams variable and allworkerteams variable
        // Workerteams variable is active variable and allworkerteams is for later usage for accessing all original workerteams
        for (let i = 0; i < Object.keys(data.workerteams).length; i++) {
          const status = Object.values(data.workerteams)[i] as { name: string, status_id: number };
          this.workerteams.push({ values: status, id: Object.keys(data.workerteams)[i], show: true })
        }

        for (let key of Object.keys(data.workerteams)) {
          const status = data.workerteams[key];
          this.workerteamStatuses.add({ statusId: status['status_id'], statusName: status.name, workerteamId: +key });
        }

        this.currentUser = data.id;
        if (this.workerteams.length > 0) {
          let json = localStorage.getItem('field-reporting-workerteam-solar')
          if (json) {
            let workerteamId = JSON.parse(json).id
            if (workerteamId && this.workerteams.find(c => c.id === workerteamId)) {
              let workerteam = this.workerteams.find(c => c.id === workerteamId)
              this.currentWorkerteam = workerteam
            } else {
              this.workerteams[0].show = false
              this.currentWorkerteam = this.workerteams[0]
            }
          } else {
            this.workerteams[0].show = false
            this.currentWorkerteam = this.workerteams[0]
          }
          if (this.currentWorkerteam) this.currentStatusId = this.currentWorkerteam.values.status_id;
          this.getAllStatuses(this.currentProjectId).subscribe(statusData => {
            this.allStatuses = statusData.message;
            forkJoin([
              this.getWorkerteamOrders()
            ]).subscribe(() => { });
          });

          this.getBases(this.currentProjectId);
        }
      });
  }

  private processStatuses(statuses: Status[], doneWorkOrders: WorkOrder[]): any[] {
    const results: any[] = [];

    for (let status of statuses) {
      const statusClone = structuredClone(status);
      statusClone.definition = this.getStatusName(status.id);

      const workOrderCount = {
        amount: 0,
      };

      for (let workOrder of this.workOrders) {
        if (workOrder.status_id == statusClone.id) {
          workOrderCount.amount++;
        }
      }

      const doneIds: number[] = [];
      for (let doneWorkOrder of doneWorkOrders) {
        if (doneWorkOrder.status_id == statusClone.id) {
          doneIds.push(doneWorkOrder.id);
        }
      }

      const workOrderStatus = {
        ...statusClone,
        workorders: {
          amount: workOrderCount.amount,
          doneids: doneIds,
          doneidsmap: new Map<number, boolean>(),
        }
      }

      results.push(workOrderStatus);
    }

    return results;
  }

  /**
   * Switch project by pressing another project in list from interface
   * @param projectId correct project id to change to
   */
  switchProject(projectId) {
    this.userService.updateCurrentProject(this.currentUser, projectId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(
        () => window.location.reload()
      )
  }

  hasReservation(workorder) {
    if (workorder && workorder.reservations) {
      const reservationKeys = Object.keys(workorder.reservations).map(Number);
      if (reservationKeys.includes(parseInt(this.currentWorkerteam.id))) {
        return true
      }
    }
    return false
  }

  /**
   * Go through work orders that workerteam has and apply data accordingly
   */
  getWorkerteamOrders(): Observable<any> {
    this.toDoCount = 0;
    this.doneCount = 0;
    this.freeLocationsCount = 0;

    this.workOrdersLoading = true;
    this.displayedWorkOrders = [];
    this.workOrderArray = [];
    this.mustDoForTodayOrders = [];
    this.allWorkOrders = {};
    let status = this.allStatuses.find(status => status.id == this.currentStatusId);
    this.type = status?.type;

    if (!this.type) {
      this.toastService.sendToast(false, this.translateService.instant('fieldReporting.dashboard.statusNotFound'));
    }

    return iif(
      () => this.type == 4,
      defer(() =>
        this.getFieldReportingWorkOrders$(4),
      ),
      this.getFieldReportingWorkOrders$(this.type)
    ).pipe(
      finalize(() => {
        this.getDoneWorkOrders(this.currentWorkerteam.id);
        this.getLocation();
        this.filterWorkOrders({ type: MultiSelectSearchTypes.POWERLINE, workOrders: this.workOrders });
        this.workOrdersLoading = false;
      })
    );
  }

  private getFieldReportingWorkOrders$(statusType: number): Observable<any> {
    if (!this.currentWorkerteam?.id) {
      console.error('No workerteam');
      return of(false);
    }

    return this.fieldReporting.getFieldReporting(statusType, this.currentWorkerteam.id).pipe(
      tap(data => {
        Object.assign(this.allWorkOrders, data.all);
        this.workOrders = [];

        Object.values(this.allWorkOrders).forEach((workorder: WorkOrder) => {
          this.workOrders.push(workorder);
          if (this.hasReservation(workorder) || statusType === 3) {
            this.workOrderArray.push(workorder)
          }
        });

        this.workOrdersInCalendar = this.workOrders.filter(workOrder => this.hasReservation(workOrder));
        let todaysOrders: WorkOrder[] = data.today;

        Object.values(todaysOrders).forEach((workorder: WorkOrder) => {
          if (this.hasReservation(workorder) || statusType === 3) {
            this.mustDoForTodayOrders.push(workorder)
          }
        });
      }),
    );
  }

  getDoneWorkOrders(teamId: number): void {
    this.fieldReporting.getDoneWorkOrdersForTeam(Number(teamId), this.type).pipe(
      tap(data => {
        this.doneOrders = data;
        this.tabChanger(this.tab)
        this.initMap()
        this.recenterMapOnWorkOrders();
      }),
      catchError(error => {
        console.error('Error fetching done work orders:', error);
        return of([]);
      })
    ).subscribe({
      next: (doneWorkOrders: WorkOrder[]) => {
        this.allStatusesMultiFilter = this.processStatuses(this.allStatuses, doneWorkOrders);
        this.initStorage();
      },
      error: error => {

      }
    });
  }

  getAllStatuses(projectId): Observable<any> {
    return this.plannerProjectService.getStatuses(projectId)
  }


  initMap() {

    this.getCenterCoordinates();

    if (this.map) {
      this.drawWorkOrders();
      return;
    }


    this.map = L.map('mapmap', { editable: true });


    this.map.zoomControl.setPosition('topright');

    this.basemapService.attach(this.map, { customerId: this.customerId, minZoom: 2, maxZoom: 23 });

    this.map.on('locationerror', () => {
      this.map.panTo({ lat: this.centerLatitude, lon: this.centerLongitude });
    });

    // Set the initial center of the map
    this.centerMap()

    this.drawWorkOrders();

    this.addZoomListener();
  }

  getCenterCoordinates(): boolean {

    const center = this.customerSettingsService.getCenterCoordinates(
      this.customerId,
      CustomerSettingsComponents.FieldReportingDashboard
    );

    if (!center.latitude || !center.longitude) return false;

    this.centerLatitude = center.latitude;
    this.centerLongitude = center.longitude;
    return true;
  }


  private getCenterFromWorkOrders(workOrders: WorkOrder[]): { latitude: number; longitude: number } | null {
    if (!Array.isArray(workOrders) || workOrders.length === 0) return null;

    const points = workOrders
      .map(wo => ({
        lat: Number((wo as any).latitude),
        lng: Number((wo as any).longitude),
      }))
      .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));

    if (points.length === 0) return null;

    // center of bounding box (simple + stable)
    let minLat = points[0].lat, maxLat = points[0].lat;
    let minLng = points[0].lng, maxLng = points[0].lng;

    for (const p of points) {
      if (p.lat < minLat) minLat = p.lat;
      if (p.lat > maxLat) maxLat = p.lat;
      if (p.lng < minLng) minLng = p.lng;
      if (p.lng > maxLng) maxLng = p.lng;
    }

    return {
      latitude: (minLat + maxLat) / 2,
      longitude: (minLng + maxLng) / 2,
    };
  }

  private recenterMapOnWorkOrders(): void {
    if (this.customerId !== CustomerIds.POWERLINES) return;
    if (!this.map) return;

    const center = this.getCenterFromWorkOrders(this.workOrders);
    if (center) {
      this.map.panTo([center.latitude, center.longitude]);
    }
  }

  centerMap() {
    const initialCenter = L.latLng(this.centerLatitude, this.centerLongitude);
    let mapZoom = 16
    if (this.customerId === 3) mapZoom = 11
    else if (this.customerId === 4) mapZoom = 17
    this.map.setView(initialCenter, mapZoom);
  }


  drawWorkOrders(filteredWorkOrders?: WorkOrder[], filterByStatus?: boolean) {
    // Remove any existing work order markers from the map
    if (this.workOrderMarkers) this.workOrderMarkers.forEach(marker => marker.remove());
    if (this.powerLineWorkOrderMarkers) this.powerLineWorkOrderMarkers.forEach(marker => marker.remove());

    this.workOrderMarkers.clear();
    this.powerLineWorkOrderMarkers.clear();
    const currentZoomLevel = this.map.getZoom(); // Get current zoom level
    const canvasRenderer = L.canvas(); // Create a canvas renderer

    // Using multi filter
    if (filteredWorkOrders !== undefined && filteredWorkOrders !== null) {
      for (let workOrder of filteredWorkOrders) {
        if (this.isPowerlineWorkOrder(workOrder)) {
          this.drawPowerlineWorkOrder(workOrder);
        }
      }

      return;
    }

    Object.values(this.allWorkOrders).forEach((workOrder: WorkOrder) => {
      if (this.isPowerlineWorkOrder(workOrder)) {
        this.drawPowerlineWorkOrder(workOrder);
        return;
      }

      let [color, border] = [workOrder.color, workOrder.bordercolor]
      let realWorkOrder = this.doneOrders.find(order => order.id === workOrder.id)
      if (realWorkOrder) [color, border] = [realWorkOrder.color, realWorkOrder.bordercolor]
      let opacity = 1
      let size = MapUtils.getRelativeMarkerSize(workOrder.frame_size, currentZoomLevel, this.customerId)
      const lat = Number(workOrder.latitude);
      const lng = Number(workOrder.longitude);

      if (!isNaN(lat) && !isNaN(lng) && this.map) {
        const marker = L.customRectangleMarker([lat, lng], {
          renderer: canvasRenderer,
          size: size,
          fillColor: color,
          color: border,
          opacity: opacity,
          fillOpacity: opacity,
          weight: 1, // Ensure the border weight is specified
          isSelected: false, // Initialize as not selected,
          frame_size: workOrder.frame_size
        }).addTo(this.map);

        marker.workOrder = workOrder;
        marker.color = color;
        marker.border = border;

        marker.on('click', () => {
          this.selectedBase = null;
          this.resetSearch = true;

          if (this.selectedWorkOrder && this.selectedWorkOrder.id === workOrder.id) {
            // Deselect if the same work order is clicked again
            this.deselectWorkOrder();
            this.updateMarkerStyle(marker, color, border, opacity, false);
          } else {
            // Deselect the previously selected work order, if any
            if (this.selectedMarker && this.selectedWorkOrder) {
              let [color, bordercolor] = [this.selectedWorkOrder.color, this.selectedWorkOrder.bordercolor]
              let realWorkOrder = this.doneOrders.find(order => order.id == this.selectedWorkOrder?.id)
              if (realWorkOrder) [color, bordercolor] = [realWorkOrder.color, realWorkOrder.bordercolor]
              this.updateMarkerStyle(this.selectedMarker, color, bordercolor, opacity, false)
              this.deselectWorkOrder()
            }
            // Select the new work order
            this.selectedWorkOrder = workOrder;
            if (this.doneOrders.some(order => order.id === workOrder.id)) {
              let order = this.doneOrders.find(order => order.id === workOrder.id);
              this.selectedWorkOrder['rid'] = order ? order.rid : 0
              this.selectedWorkOrder['notes'] = order?.notes
            }
            // Load interruptions for the selected workorder
            this.loadInterruptionsForWorkOrder(workOrder.id);
            this.selectedMarker = marker;
            this.updateMarkerStyle(marker, color, border, opacity, true);
            // Trigger Angular's change detection to update the view
            this.changeDetectorRef.detectChanges();
            // Setup event listeners to prevent map interaction when touching details
            this.setupDetailsContainerEventListeners();
          }
        });

        // Add the marker to the workOrderMarkers array for later access
        this.workOrderMarkers.set(workOrder.id, marker);
      } else {
        console.error("Error, problem with workorder coordinates");
      }
    });
  }

  private drawPowerlineWorkOrder(workOrder: WorkOrder): void {
    let doneWorkOrder = this.doneOrders.find(order => order.id === workOrder.id);
    const marker = this.createPowerLineMarker(doneWorkOrder ?? workOrder);

    marker.on('click', () => {
      this.selectedBase = null;
      this.resetSearch = true;

      if (this.selectedWorkOrder && this.selectedWorkOrder.id === workOrder.id) {
        this.deselectWorkOrder();
        return;
      }

      if (this.selectedMarker && this.selectedWorkOrder) {
        this.deselectWorkOrder()
      }

      this.selectedWorkOrder = workOrder;
      if (this.doneOrders.some(order => order.id === workOrder.id)) {
        const order = this.doneOrders.find(order => order.id === workOrder.id);
        this.selectedWorkOrder['rid'] = order ? order.rid : 0
        this.selectedWorkOrder['notes'] = order?.notes
      }
      // Load interruptions for the selected workorder
      this.loadInterruptionsForWorkOrder(workOrder.id);

      this.selectedMarker = marker;
      // Setup event listeners to prevent map interaction when touching details
      setTimeout(() => this.setupDetailsContainerEventListeners(), 100);
    });
  }

  createIcon(size: number, color) {
    return L.divIcon({
      className: '',
      iconSize: [size, size], // square size
      html: `<div style="width: 85%; height: 70%; background-color: ${color}; opacity: 1;"></div>`
    });
  }


  closeDetails(): void {
    if (this.selectedMarker && this.selectedWorkOrder) {
      let [color, bordercolor] = [this.selectedWorkOrder.color, this.selectedWorkOrder.bordercolor]
      let realWorkOrder = this.doneOrders.find(order => order.id == this.selectedWorkOrder?.id)
      if (realWorkOrder) [color, bordercolor] = [realWorkOrder.color, realWorkOrder.bordercolor]
      if (!this.isPowerlineWorkOrder(this.selectedWorkOrder)) {
        this.updateMarkerStyle(this.selectedMarker, color, bordercolor, 1, false)
      }

      this.selectedWorkOrder = null;
      this.selectedWorkOrderInterruptions = [];
      this.showInterruptions = false;
    }

    if (this.selectedBase) {
      this.selectedBase = null;
      this.selectedBaseReport = null;
    }
    // If you're using ChangeDetectorRef, you might need to call detectChanges()
    // this.changeDetectorRef.detectChanges();
  }

  // Check if we show create report button
  // if order doesn't belong to user, return false
  // if it does, but is already reported, return false
  // ...unless the report is interrupt, in which case return true
  // otherwise return true
  showCreateButton(workOrder: WorkOrder): boolean {
    let order = this.workOrderArray.find(order => order.id === workOrder.id)
    if (order) {
      if (order.interrupted) {
        return false
      }
      else if ((workOrder && this.hasReservation(workOrder)) || workOrder.type === 3) {
        let doneOrder = this.doneOrders.find(order => order.id === workOrder.id)
        if (doneOrder) {
          if (doneOrder.report_type == 2) {
            return true
          }
        } else {
          return true
        }
      }
    }
    return false
  }

  // Check if we show update report button
  // if workorder has a report, return true
  // ...unless there already is higher level report, in which case return false
  // otherwise return false
  showUpdateButton(workOrder: WorkOrder, skipHigherReportCheck = false): boolean {
    if (workOrder.rid && workOrder.rid > 0) {
      if (!skipHigherReportCheck && this.hasHigherReport(workOrder)) {
        return false
      }
      return true
    }
    return false
  }

  hasHigherReport(workOrder: WorkOrder): boolean {
    // todo what about if next phase is reported, but this one is not?
    // todo that doesn't show in doneOrders
    let doneOrder = this.doneOrders.find(order => order.id === workOrder.id)
    if (doneOrder && doneOrder.hashigherreport == 1) {
      return true
    }
    return false
  }

  // Method to deselect the current work order
  deselectWorkOrder(): void {
    if (this.selectedMarker) {
      //this.resetMarkerStyle(this.selectedMarker);
      this.selectedMarker = null;
    }
    this.selectedWorkOrder = null;
    this.selectedWorkOrderInterruptions = [];
    this.showInterruptions = false;
    // Trigger Angular's change detection to update the view
    this.changeDetectorRef.detectChanges();
  }

  // Method to update the marker style for the selected marker
  updateMarkerStyle(marker, color, border, opacity, isSelected) {
    if (isSelected) {
      // Update the marker to be white with a black outline
      marker.setStyle({
        fillColor: 'white',
        color: 'black',
        fillOpacity: opacity,
        weight: 2 // Adjust the outline thickness as needed
      });
    } else {
      // Revert to the original style
      marker.setStyle({
        fillColor: color,
        color: border,
        fillOpacity: opacity,
        weight: 1 // Adjust the outline thickness as needed
      });
    }

    // Update the isSelected property
    marker.options.isSelected = isSelected;
  }

  // Method to reset the marker style for the deselected marker
  // resetMarkerStyle(marker: L.Marker): void {
  //   const workOrder = (marker as any).workOrder as WorkOrder; // Type assertion
  //   const color = this.getWorkOrderColor(workOrder);
  //   const newSize = this.calculateIconSizeBasedOnZoom(this.map.getZoom());
  //   const defaultIcon = L.divIcon({
  //     className: '',
  //     iconSize: [newSize, newSize], // Adjust the size if needed
  //     html: `<div style="width: 85%; height: 70%; background-color: ${color}; opacity: 1;"></div>`,
  //   });

  //   marker.setIcon(defaultIcon);
  // }


  getStatusColor(statusId: number): string {
    for (let status of this.allStatuses) {
      if (status.id === statusId) {
        return status.color;
      }
    }
    return 'white';
  }



  createReport(): void {
    // Logic to create a report for the selected work order
    // ...
  }

  getStatusName(statusId: number): string {
    for (let i = 0; i < this.allStatuses.length; i++) {
      if (this.allStatuses[i].id === statusId) {
        const definition = JSON.parse(this.allStatuses[i].definition);
        return definition.en; // Get the English translation for now
      }
    }
    return 'Unknown';
  }

  getPowerlineStatusName(workOrder: WorkOrder): string {
    if (!workOrder?.priority_status?.definition) return 'Unknown';
    const definition = JSON.parse(workOrder.priority_status.definition);

    return definition?.[this.lang] ? definition[this.lang] : 'Unknown';
  }

  /**
   * Change tab so that we display correct information in interface
   */
  tabChanger(tab) {
    this.topIcon = 0
    this.tab = tab
    if (tab == 3) {
      this.displayedWorkOrders = this.doneOrders
    }
    else if (tab == 0) {
      this.onTabSwitchedToMap();
    }
    // this.changeFilter(this.sortChoise)
    this.setTabTitle()
  }

  onTabSwitchedToMap() {
    if (this.map) {
      setTimeout(() => this.map.invalidateSize(), 0);
    } else {
      this.initMap();
    }
  }

  expandArrowListener(id) {
    var img = document.getElementById('arrowImg-' + id) as HTMLImageElement

    if (img.src.includes('expand_more_blue_24dp.svg')) {
      img.src = 'assets/icons/expand_less_blue_24dp.svg'

    } else if (img.src.includes('expand_less_blue_24dp.svg')) {
      img.src = 'assets/icons/expand_more_blue_24dp.svg'
    }
  }

  setTabTitle() {
    if (this.tab == 1) {
      this.tabTitle = 'All'
    } else if (this.tab == 2) {
      this.tabTitle = 'Must do for today'
    } else if (this.tab == 3) {
      this.tabTitle = 'Done'
    }
  }

  toSingleWorkOrder(workOrder, wid, mode) {
    let id = workOrder.id
    let rid = workOrder.rid

    if (this.customerId !== 3) {
      let queryParamsValue: Params = {
        wid: wid,
        coordinates: `${workOrder.latitude},${workOrder.longitude}`,
        zoom: this.map.getZoom(),
      };

      if (rid > 0) {
        queryParamsValue['rid'] = rid;
      }

      let url = '/field-reporting/report/' + id
      this.router.navigate([url], {
        queryParams: queryParamsValue,
        queryParamsHandling: 'merge'
      });
    } else {
      let url = '/field-reporting/powerlines-report/' + id
      let queryParamsValue: Params = {
        wid: wid,
        coordinates: `${workOrder.latitude},${workOrder.longitude}`,
        zoom: this.map.getZoom(),
      };

      if (mode == 'update' || mode == 'create') {
        queryParamsValue['statusId'] = this.currentStatusId;
      }

      // Pass reservations data via router state
      this.router.navigate([url], {
        queryParams: queryParamsValue,
        queryParamsHandling: 'merge',
        state: { reservations: workOrder.reservations || {} }
      });
    }

    return true
  }

  /**
   * Sets attributes dynamically to color and borderm-bottom
   * @param tabId tabId which is 1-3
   * @returns correct color and border-botto attribute for tab
   */
  styleObject(tabId): Object {
    if (this.tab == tabId) return { 'color': '#0058ff', 'border-bottom': '#0058ff 4px solid' }
    else return { 'color': 'gray', 'border-bottom': '0px solid white' }
  }

  /**
   * Switches to correct workerteam, removes correct workerteam from list and runs getWorkerteamOrders function
   * @param id what workerteam we want to switch to
   */
  switchWorkerteam(id) {
    this.workerteams.forEach(d => d.show = true)
    let workerteam = this.workerteams.find(c => c.id === id)
    if (workerteam) {
      workerteam.show = false
      this.currentWorkerteam = workerteam
      this.currentStatusId = parseInt(workerteam.values.status_id)
      localStorage.setItem('field-reporting-workerteam-solar', JSON.stringify({ id: workerteam.id }))
    }

    this.getWorkerteamOrders().subscribe(() => { });
    this.assignedOnlyChecked = false;
  }

  /**
   * Toggle dashboard on and hide single order detail. Also change runGetWorkOrder to false so
   * that it can be changed to true when needs to be run in single order detail component. This function is
   * called when single order detail is closed
   */
  showDashboardToggle() {
    this.showDashboard = true;
    this.showSingleOrderDetail = false;
    this.runGetWorkOrder = false;
  }

  timeWindowToHours(time: string): string {
    return DateUtils.toLocalHours(time);
  }

  timeWindowToDate(time: string): string {
    return DateUtils.toLocalDate(time);
  }

  formatReportDate(dateString: string): string {
    return DateUtils.formatUtcToLocal(dateString, 'date');
  }

  formatReportTime(dateString: string): string {
    return DateUtils.formatUtcToLocal(dateString, 'time');
  }

  formatReportDateTime(dateString: string): string {
    return DateUtils.formatUtcToLocal(dateString, 'datetime');
  }

  setCornerIcon(accessType) {
    if (accessType == 3) return "assets/icons/key_blue_24dp.svg"
    else if (accessType == 2) return "assets/icons/person_lock_blue_24dp.svg"
    else if (accessType == 1) return "assets/icons/lock_unlocked_blue_24dp.svg"
    else return null
  }

  getLocation(): void {
    const coordinates = this.route.snapshot.queryParamMap.get('coordinates');
    const zoom = this.route.snapshot.queryParamMap.get('zoom');

    if (coordinates) {
      const latLng = coordinates.split(',');
      if (latLng?.length <= 1) return;

      this.lat = +latLng[0];
      this.lon = +latLng[1];
      this.map.setView([this.lat, this.lon], zoom || this.map.getZoom());

      this.router.navigate([], {
        queryParams: { coordinates: null, zoom: null },
        queryParamsHandling: 'merge',
      });

      return;
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lon = position.coords.longitude;

        if (this.lat && this.lon
          && ((this.inBBOXFin(this.lat, this.lon)
            || this.inBBOXSwe(this.lat, this.lon)
            || this.inBBOXHallavahti(this.lat, this.lon)
            || this.inBBOXPowerlines(this.lat, this.lon))
          )) {
          this.centerLatitude = this.lat;
          this.centerLongitude = this.lon;

          // Center the map on the user's location
          this.map.setView([this.lat, this.lon], this.map.getZoom());

          // If inside BBOX, use current location
          const marker = L.marker([this.lat, this.lon], {
            icon: L.divIcon({
              className: '',
              iconSize: [16, 16], // square size
              html: `<div style="width: 100%; height: 100%; background-color: #00CED1; border-radius: 50%; border: 1px solid black;"></div>`
            })
          }).addTo(this.map)
            .bindPopup(this.translateService.instant('fieldReporting.dashboard.youAreHere')).openPopup();

          setTimeout(() => {
            marker.closePopup();
          }, 2000);

          this.locationMarker = marker;

          navigator.geolocation.watchPosition(position => {
            const crd = position.coords;
            this.lat = crd.latitude;
            this.lon = crd.longitude;
            let latlng = new L.LatLng(this.lat, this.lon);
            this.locationMarker.setLatLng(latlng);
          }, (error) => {
            console.error("Error occurred. Error code: " + error.code);
          }, {
            enableHighAccuracy: true,
            maximumAge: 30000,
            timeout: 27000
          });
        }
      });
    } else {
      console.error("No support for geolocation");
    }
  }

  //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies
  calcDistance(lat1, lon1, lat2, lon2) {
    let Radius = 6371; // km
    let dLat = this.toRad(lat2 - lat1);
    let dLon = this.toRad(lon2 - lon1);
    lat1 = this.toRad(lat1);
    lat2 = this.toRad(lat2);
    let returnVal = ""

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = Radius * c; // km

    return d
  }

  // Converts numeric degrees to radians
  toRad(Value) {
    return Value * Math.PI / 180;
  }

  inBBOXFin(lat, lon) {
    return (
      lat >= this.BBOXFin.sw.lat && lat <= this.BBOXFin.ne.lat &&
      lon >= this.BBOXFin.sw.lon && lon <= this.BBOXFin.ne.lon
    );
  }

  inBBOXSwe(lat, lon) {
    return (
      lat >= this.BBOXSwe.sw.lat && lat <= this.BBOXSwe.ne.lat &&
      lon >= this.BBOXSwe.sw.lon && lon <= this.BBOXSwe.ne.lon
    );
  }

  inBBOXHallavahti(lat, lon) {
    return (
      lat >= this.BBOXHallavahti.sw.lat && lat <= this.BBOXHallavahti.ne.lat &&
      lon >= this.BBOXHallavahti.sw.lon && lon <= this.BBOXHallavahti.ne.lon
    );
  }

  inBBOXPowerlines(lat, lon) {
    return this.BBOXPowerlines.some(bbox =>
      lat >= bbox.sw.lat && lat <= bbox.ne.lat &&
      lon >= bbox.sw.lon && lon <= bbox.ne.lon
    );
  }

  setUpCustomRectangleCanvas() {
    L.Canvas.include({
      _updateCustomRectangle: function (layer) {
        const ctx = this._ctx;
        const p = layer._point;
        const size = layer.options.size;
        const halfWidth = size[0] / 2;
        const halfHeight = size[1] / 2;

        ctx.save();
        ctx.beginPath();
        ctx.rect(p.x - halfWidth, p.y - halfHeight, size[0], size[1]);
        ctx.fillStyle = layer.options.fillColor;
        ctx.fill();
        ctx.strokeStyle = layer.options.color;
        ctx.lineWidth = layer.options.weight;
        ctx.stroke();
        ctx.restore();
      }
    });

    L.CustomRectangleMarker = L.CircleMarker.extend({
      options: {
        size: [20, 10], // width, height
      },

      _updatePath: function () {
        this._renderer._updateCustomRectangle(this);
      },

      // Override hit test for rectangle
      _containsPoint: function (p) {
        const size = this.options.size;
        const halfWidth = size[0] / 2;
        const halfHeight = size[1] / 2;
        const center = this._point;
        return (
          p.x >= center.x - halfWidth &&
          p.x <= center.x + halfWidth &&
          p.y >= center.y - halfHeight &&
          p.y <= center.y + halfHeight
        );
      }
    });

    L.customRectangleMarker = function (latlng, options) {
      return new L.CustomRectangleMarker(latlng, options);
    };
  }


  setUpCustomTextMarkerCanvas() {
    L.Canvas.include({
      _updateCustomText: function (layer) {
        const ctx = this._ctx;
        const p = layer._point;
        const text = layer.options.text;
        const fontSize = layer.options.fontSize || 12;
        const fontColor = layer.options.fontColor || 'black';

        ctx.save();
        ctx.font = `${fontSize}px Arial`;
        ctx.fillStyle = fontColor;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, p.x, p.y);
        ctx.restore();
      }
    });

    L.CustomTextMarker = L.CircleMarker.extend({
      options: {
        text: '',
        fontSize: 12,
        fontColor: 'black'
      },

      _updatePath: function () {
        this._renderer._updateCustomText(this);
      }
    });

    L.customTextMarker = function (latlng, options) {
      return new L.CustomTextMarker(latlng, options);
    };

  }

  getRowNumbers(projectId): Observable<RowNumber[]> {
    return this.workOrderService.getRowNumbers(projectId).pipe(
      tap((rowNumbers: RowNumber[]) => {
        this.rowNumbers = rowNumbers;
      })
    );
  }

  drawRowNumbersOnMap(): void {
    // Remove any existing row number markers from the map
    if (this.rowNumberMarkers) {
      this.rowNumberMarkers.forEach(marker => marker.remove());
    }
    this.rowNumberMarkers = new Map<number, L.Layer>(); // Reset the row number markers array

    const canvasRenderer = L.canvas(); // Create a canvas renderer

    this.rowNumbers.forEach((rowNumber) => {
      const lat = Number(rowNumber.position_x);
      const lng = Number(rowNumber.position_y);

      if (!isNaN(lat) && !isNaN(lng)) {
        // Create a custom text marker
        const marker = L.customTextMarker([lat, lng], {
          renderer: canvasRenderer,
          text: rowNumber.number.toString(),
          fontSize: 12, // Adjust font size as needed
          fontColor: 'black' // Adjust font color as needed
        }).addTo(this.map);

        // Add the marker to the rowNumberMarkers array
        this.rowNumberMarkers.set(rowNumber.id, marker);
      } else {
        console.error(`Invalid coordinates for row number id=${rowNumber.id}: lat=${lat}, lng=${lng}`);
      }
    });
  }

  private getBases(projectId: number): void {
    if (this.customerId !== 3) return;

    this.getBaseReports$()
      .pipe(
        switchMap(() => this.routePlanningService.getBases(projectId))
      ).subscribe(bases => {
        bases.forEach(base => {
          this.basesMap.set(base.id, base);
          this.createBaseIcon(base);
        });
      });
  }

  private getBaseReports$(): Observable<BaseReport[]> {
    if (this.customerId !== 3 || !this.currentProjectId) return of([]);

    return this.routePlanningService.getBaseReports(this.currentProjectId)
      .pipe(tap(reports => {
        this.baseReports = [];
        for (const report of reports) {
          this.baseReports.push(report);
          this.baseReportsMap.set(report.base_id, report);
        }
      }));
  }

  public getBaseReportsForSelectedBase(baseId: number): BaseReport[] {
    return this.baseReports.filter(report => report.base_id === baseId);
  }

  private createBaseIcon(base: RoutePlanningBase): void {
    const point = new L.LatLng(base.coordinates.lat, base.coordinates.lng);

    const circle = L.circleMarker(point, {
      radius: 13,
      color: this.baseHasReport(base.id) ? '#00cc00' : 'blue',
      fillColor: this.baseHasReport(base.id) ? '#00cc00' : 'blue',
      fillOpacity: 1,
      weight: 4,
    }).addTo(this.map);

    const customIcon = L.icon({
      iconUrl: '/assets/icons/powerlines/base.png',
      iconSize: [24, 24],
      iconAnchor: [12, 12],
      popupAnchor: [0, -20]
    });

    const marker = L.marker(point, { icon: customIcon }).addTo(this.map);

    const title = base.identifier
      ? base.identifier
      : this.translateService.instant('planner.routePlanning.base') + ' #' + base.id;

    const tooltip = marker.bindTooltip(`
      <div class="title">${title}</div>
      ${base.notes ? '<div class="notes">' + base.notes + '</div>' : ''}
    `, {
      permanent: true,
      direction: 'bottom',
      offset: [0, 10],
      className: 'my-transparent-tooltip'
    }).getTooltip();

    // needed to adjust the initial tooltip position because of white-space: break-spaces
    if (tooltip) tooltip.update();
    this.baseMarkers.set(base.id, marker);

    marker.on('click', () => {
      this.deselectWorkOrder();
      this.selectedBase = base;
      this.selectedBaseReports = this.getBaseReportsForSelectedBase(base.id);
      // Setup event listeners to prevent map interaction when touching base details
      setTimeout(() => this.setupDetailsContainerEventListeners(), 100);
    });
  }

  baseHasReport(base_id: number): boolean {
    return this.baseReportsMap.has(base_id);
  }

  createBaseReport(base: RoutePlanningBase, wid: number): void {
    const rid = this.baseReportsMap.get(base.id)?.id;
    let queryParams: Params = { wid: wid, baseReport: true, baseIdentifier: base.identifier };
    if (rid) queryParams['rid'] = rid;

    let url = '/field-reporting/report/' + base.id
    this.router.navigate([url], {
      queryParams,
      queryParamsHandling: 'merge'
    });
  }

  viewBaseReport(report: BaseReport, base: RoutePlanningBase): void {
    this.selectedBaseReport = {
      ...report,
      images: []
    };
    this.loadingBaseReportImages = true;
    this.loadImagesForSelectedReport(report.id);
  }

  private loadImagesForSelectedReport(reportId: number): void {
    this.workOrderService.getReportImages(reportId, 'base_reports')
      .subscribe(data => {
        if (!data || data.length === 0) {
          this.loadingBaseReportImages = false;
          this.changeDetectorRef.detectChanges();
          return;
        }

        const imagePromises: Promise<any>[] = [];

        data.forEach(image => {
          const promise = new Promise((resolve) => {
            this.workOrderService.fetchImage(image.id).subscribe(imageUrl => {
              if (imageUrl) {
                image.old = true;
                image.img = imageUrl;
                resolve(image);
              } else {
                resolve(null);
              }
            }, error => {
              console.error('Error fetching image', image.id, error);
              resolve(null);
            });
          });
          imagePromises.push(promise);
        });

        Promise.all(imagePromises).then(images => {
          const validImages = images.filter(img => img !== null);
          this.selectedBaseReport.images = validImages;
          this.loadingBaseReportImages = false;
          this.changeDetectorRef.detectChanges();
        });
      }, error => {
        console.error('Error getting report images', error);
        this.loadingBaseReportImages = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  closeSelectedBaseReport(): void {
    this.selectedBaseReport = null;
    this.loadingBaseReportImages = false;
  }

  private getRoutes(projectId: number): void {
    this.routePlanningService.getRoutes(projectId)
      .subscribe(routes => {
        routes.forEach(route => {
          this.createRoutePolyline(route);
        });
      });
  }

  private getRouteNotes(projectId: number): void {
    this.routeNoteMarkers.forEach(marker => marker.removeFrom(this.map));
    this.routeNoteMarkers.clear();

    this.routePlanningService.getRouteNotes(projectId)
      .subscribe(routeNotes => {
        routeNotes.forEach(routeNote => {
          const marker = MapUtils.createRouteNoteIcon(routeNote);
          this.routeNoteMarkers.set(routeNote.id, marker);

          marker.bindTooltip(routeNote.notes, {
            direction: 'top',
            offset: [0, -10],
            className: 'route-note-tooltip'
          });

          marker.addTo(this.map);

          // long press detection for opening the edit modal
          let longPressTimer: any = null;
          let isLongPress = false;
          let touchStartX = 0;
          let touchStartY = 0;
          let hasMovedSignificantly = false;

          const startLongPress = (x?: number, y?: number) => {
            isLongPress = false;
            hasMovedSignificantly = false;
            if (x !== undefined && y !== undefined) {
              touchStartX = x;
              touchStartY = y;
            }
            longPressTimer = setTimeout(() => {
              if (!hasMovedSignificantly) {
                isLongPress = true;
                this.openRouteNotesModal('EDIT', routeNote);
              }
            }, 500);
          };

          const cancelLongPress = () => {
            if (longPressTimer) {
              clearTimeout(longPressTimer);
              longPressTimer = null;
            }
          };

          const toggleTooltip = () => {
            if (!isLongPress) {
              if (marker.isTooltipOpen()) {
                marker.closeTooltip();
              } else {
                marker.openTooltip();
              }
            }
          };

          marker.on('mousedown', () => {
            startLongPress();
          });

          marker.on('mouseup', () => {
            cancelLongPress();
            toggleTooltip();
          });

          marker.on('mouseout', () => {
            cancelLongPress();
          });

          // touch events for mobile
          const element = marker.getElement();
          if (element) {
            element.addEventListener('touchstart', (e) => {
              e.preventDefault();
              e.stopPropagation();
              const touch = e.touches[0];
              startLongPress(touch.clientX, touch.clientY);
            }, { passive: false });

            element.addEventListener('touchmove', (e) => {
              // allow small movements without canceling
              if (e.touches.length > 0) {
                const touch = e.touches[0];
                const deltaX = Math.abs(touch.clientX - touchStartX);
                const deltaY = Math.abs(touch.clientY - touchStartY);

                // if moved more than 10px in any direction, cancel long press
                if (deltaX > 10 || deltaY > 10) {
                  hasMovedSignificantly = true;
                  cancelLongPress();
                }
              }
            }, { passive: true });

            element.addEventListener('touchend', (e) => {
              e.preventDefault();
              e.stopPropagation();
              cancelLongPress();
              toggleTooltip();
              hasMovedSignificantly = false;
            }, { passive: false });

            element.addEventListener('touchcancel', () => {
              cancelLongPress();
              hasMovedSignificantly = false;
            });
          }
        });
      });
  }

  private createRoutePolyline(route: RoutePlanningRoute): void {
    if (route?.coordinates?.length < 2) return;

    const options = ROUTE_PLANNER_POLYLINE_SHAPE_OPTIONS;
    options.color = route.color || ROUTE_PLANNER_POLYLINE_COLOR;
    options.originalColor = route.color || ROUTE_PLANNER_POLYLINE_COLOR;

    const polylineLayer = L.polyline(route?.coordinates, options)
      .bindPopup(this.getRoutePopUp(route.id));

    // used to increase the click area of the polyline
    const hitboxPolyline = L.polyline(
      route?.coordinates,
      {
        color: '#000000',
        weight: 12,
        opacity: 0,
        interactive: true,
      }
    ).bindPopup(this.getRoutePopUp(route.id));

    polylineLayer.routeId = route.id;
    this.map.addLayer(polylineLayer);

    hitboxPolyline.routeId = route.id;
    this.map.addLayer(hitboxPolyline);

    // Long press detection for creating route notes (only for POWERLINES customer)
    if (this.customerId === CustomerIds.POWERLINES) {
      let longPressTimer: any = null;
      let isLongPress = false;
      let touchStartX = 0;
      let touchStartY = 0;
      let hasMovedSignificantly = false;
      let lastClickEvent: any = null;

      const startLongPress = (event: any, x?: number, y?: number) => {
        isLongPress = false;
        hasMovedSignificantly = false;
        lastClickEvent = event;
        if (x !== undefined && y !== undefined) {
          touchStartX = x;
          touchStartY = y;
        }
        longPressTimer = setTimeout(() => {
          if (!hasMovedSignificantly && lastClickEvent) {
            isLongPress = true;
            this.openRouteNotesModal(
              'CREATE',
              { id: 0, route_id: route.id, notes: '', coordinates: lastClickEvent.latlng }
            );
          }
        }, 500);
      };

      const cancelLongPress = () => {
        if (longPressTimer) {
          clearTimeout(longPressTimer);
          longPressTimer = null;
        }
      };

      hitboxPolyline.on('mousedown', (e: any) => {
        startLongPress(e);
      });

      hitboxPolyline.on('mouseup', () => {
        cancelLongPress();
      });

      hitboxPolyline.on('mouseout', () => {
        cancelLongPress();
      });

      // Touch events for mobile
      hitboxPolyline.on('touchstart', (e: any) => {
        if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
          const touch = e.originalEvent.touches[0];
          startLongPress(e, touch.clientX, touch.clientY);
        }
      });

      hitboxPolyline.on('touchmove', (e: any) => {
        if (e.originalEvent && e.originalEvent.touches && e.originalEvent.touches.length > 0) {
          const touch = e.originalEvent.touches[0];
          const deltaX = Math.abs(touch.clientX - touchStartX);
          const deltaY = Math.abs(touch.clientY - touchStartY);

          if (deltaX > 10 || deltaY > 10) {
            hasMovedSignificantly = true;
            cancelLongPress();
          }
        }
      });

      hitboxPolyline.on('touchend', () => {
        cancelLongPress();
      });
    }

    const title = route.identifier
      ? route.identifier
      : this.translateService.instant('planner.routePlanning.route') + ' #' + route.id;

    const tooltip = polylineLayer.bindTooltip(`
      <div class="title">${title}</div>
      ${route.notes ? '<div class="notes">' + route.notes + '</div>' : ''}
    `, {
      permanent: true,
      direction: 'bottom',
      offset: [0, 10],
      className: 'my-transparent-tooltip'
    }).getTooltip();

    // needed to adjust the initial tooltip position because of white-space: break-spaces
    if (tooltip) tooltip.update();

  }

  private getRoutePopUp(routeId: number): string {
    return `
      <div class="title">${this.translateService.instant('planner.routePlanning.route')} #${routeId}</div>
    `;
  }

  onSearchChange(workOrders: WorkOrderSearch[]): void {
    this.searchPointer?.remove();
    this.resetSearch = false;

    MapUtils.resetMarkerHighlights(
      this.workOrderMarkers,
      this.highlightedMarkers,
    );

    if (this.selectedWorkOrderSearch) {
      MapUtils.highlightMarker(
        'red',
        this.workOrderMarkers,
        this.selectedWorkOrderSearch.id,
        this.highlightedMarkers,
      );

      this.selectedWorkOrderSearch = null;
      return;
    }

    for (let workOrder of workOrders) {
      MapUtils.highlightMarker(
        'red',
        this.workOrderMarkers,
        workOrder.id,
        this.highlightedMarkers,
      );
    }
  }

  onSearchClick(workOrder: WorkOrderSearch): void {
    if (!workOrder.latitude || !workOrder.longitude) return;

    MapUtils.goToLocation(this.map, Number(workOrder.latitude), Number(workOrder.longitude));
    this.resetSearch = true;
    this.selectedWorkOrderSearch = workOrder;

    this.searchPointer?.remove();
    this.searchPointer = MapUtils.createPointerMarker(workOrder.latitude, workOrder.longitude);
    this.searchPointer?.addTo(this.map);

  }

  onSearchLocationClick(workOrder: WorkOrderSearch): void {
    MapUtils.goToLocation(this.map, Number(workOrder.latitude), Number(workOrder.longitude));
  }

  private createPowerLineMarker(workOrder: WorkOrder): L.Marker {
    let color = (workOrder.priority_status ? workOrder.priority_status.color : workOrder.color) ?? '#000';

    // interrupted
    if (workOrder.interrupted) {
      color = workOrder.color;
    }

    const marker = MapUtils.getPowerlineCustomMarker(workOrder, color, 30, this.map);
    marker.bindTooltip(`${workOrder.identifier}`, {
      direction: 'top',
      offset: [0, -10]
    });

    this.powerLineWorkOrderMarkers.set(workOrder.id, marker);
    return marker;
  }

  private isPowerlineWorkOrder(workOrder: WorkOrder): boolean {
    return workOrder.type === 4;
  }

  filterWorkOrders(data: { type: number, workOrders: WorkOrder[] }): void {
    if (!this.map || !data) return;
    this.filteredWorkOrders = data.workOrders;

    const filteredWorkOrders = this.filterByStatuses
      ? this.filteredWorkOrders.filter(workOrder => {
        const reported_status_ids = workOrder.reported_status_ids?.split(',')?.map(id => +id) || [];
        if (!this.selectedWorkerteamStatusId) return false;
        if (reported_status_ids.includes(+this.selectedWorkerteamStatusId)) return workOrder;
        return false;
      })
      : this.filteredWorkOrders;

    switch (data.type) {
      case MultiSelectSearchTypes.WORK_ORDER:
        break;

      case MultiSelectSearchTypes.INVERTER:
        break;

      case MultiSelectSearchTypes.TYPE3:
        break;

      case MultiSelectSearchTypes.POWERLINE:
        this.drawWorkOrders(filteredWorkOrders);
        break;
    }
  }

  workerteamStatusOnChange(statusId: string): void {
    this.selectedWorkerteamStatusId = +statusId || null;
    this.filterByStatuses = !!this.selectedWorkerteamStatusId;
    this.filterWorkOrders({
      type: MultiSelectSearchTypes.POWERLINE,
      workOrders: this.filterByStatuses ? this.doneOrders : this.workOrders
    });
  }

  onAssignedOnlyChange(event: Event): void {
    const checkbox = event?.target as HTMLInputElement;
    this.assignedOnlyChecked = checkbox?.checked;

    if (this.assignedOnlyChecked) {
      this.storageService.set(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_ASSIGNED_ONLY, true);
      const filteredWorkOrders = this.filterAssignedWorkOrders(this.workOrders);
      this.filterWorkOrders({ type: MultiSelectSearchTypes.POWERLINE, workOrders: filteredWorkOrders });
      return;
    }

    this.storageService.remove(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_ASSIGNED_ONLY);
    this.filterWorkOrders({ type: MultiSelectSearchTypes.POWERLINE, workOrders: this.workOrders });
  }

  onReportedOnlyChange(event: Event): void {
    const checkbox = event?.target as HTMLInputElement;
    this.reportedOnlyChecked = checkbox?.checked;

    this.workerteamStatusOnChange(this.reportedOnlyChecked
      ? this.currentWorkerteam.values.status_id
      : null
    );

    if (this.reportedOnlyChecked) {
      this.storageService.set(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_REPORTED_ONLY, true);
      return;
    }

    this.storageService.remove(StorageKeys.FIELD_REPORTING_DASHBOARD_SHOW_REPORTED_ONLY);
  }

  private filterAssignedWorkOrders(workOrders: WorkOrder[]): WorkOrder[] {
    const results: WorkOrder[] = [];

    for (let workOrder of workOrders) {
      if (this.showCreateButton(workOrder)) {
        results.push(workOrder);
      }
    }

    return results;
  }

  showBaseReportsToggle(): void {
    this.showBaseReports = !this.showBaseReports;
  }

  showInterruptionsToggle(): void {
    this.showInterruptions = !this.showInterruptions;
  }

  private loadInterruptionsForWorkOrder(workOrderId: number): void {
    // Always fetch fresh status reports from API to get interruptions from all workerteams
    this.fieldReporting.getWorkOrderStatusReports(workOrderId).subscribe(statusReports => {
      if (!statusReports || Object.keys(statusReports).length === 0) {
        this.selectedWorkOrderInterruptions = [];
        return;
      }

      const interruptedReports = Object.values(statusReports).filter((re: any) => re.report_type == 2);

      interruptedReports.forEach((report: any) => {
        const status = this.allStatuses.find(status => status.id == report.status_id);
        if (!status?.definition) return;

        const definitionObj = JSON.parse(status.definition);
        if (!definitionObj?.[this.lang]) return;

        report.status = definitionObj[this.lang];
      });

      this.selectedWorkOrderInterruptions = interruptedReports as Report[];
      this.changeDetectorRef.detectChanges();
    });
  }

  openInModal(content, image: any): void {
    this.currentImg = image;
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      centered: true
    });
  }

  closeModal(): void {
    this.modalService.dismissAll();
  }
  openRouteNotesModal(mode: RouteNoteModalType, routeNote?: RouteNote): void {
    this.selectedRouteNote = null;
    this.routeNoteText = '';

    if (routeNote) {
      this.selectedRouteNote = routeNote;
      this.routeNoteText = routeNote.notes;
    }

    this.routeNoteMode = mode;
    this.routeNotesModalInstance.show();
  }

  createRouteNote() {
    if (!this.selectedRouteNote) return;

    this.selectedRouteNote.notes = this.routeNoteText;
    this.routePlanningService.createRouteNote({
      project_id: this.currentProjectId,
      route_id: this.selectedRouteNote.route_id,
      coordinates: this.selectedRouteNote.coordinates,
      notes: this.selectedRouteNote.notes,
    }).subscribe(() => {
      this.routeNotesModalInstance.hide();
      this.getRouteNotes(this.currentProjectId);
      this.toastService.sendToast(true, this.translateService.instant('fieldReporting.dashboard.routeNoteCreated'));
    });
  }

  editRouteNote() {
    if (!this.selectedRouteNote) return;

    this.routePlanningService.updateRouteNote({
      project_id: this.currentProjectId,
      route_note_id: this.selectedRouteNote.id,
      notes: this.routeNoteText,
    }).subscribe(() => {
      this.routeNotesModalInstance.hide();
      this.getRouteNotes(this.currentProjectId);
      this.toastService.sendToast(true, this.translateService.instant('fieldReporting.dashboard.routeNoteEdited'));
    });
  }

  deleteRouteNote() {
    this.routeNoteMode = 'DELETE';
  }

  confirmDeleteRouteNote() {
    if (!this.selectedRouteNote) return;

    this.routePlanningService.removeRouteNote({
      project_id: this.currentProjectId,
      route_note_id: this.selectedRouteNote.id,
    }).subscribe(() => {
      this.routeNotesModalInstance.hide();
      this.getRouteNotes(this.currentProjectId);
      this.toastService.sendToast(true, this.translateService.instant('fieldReporting.dashboard.routeNoteDeleted'));
    });
  }

  dismissDeleteRouteNote() {
    this.routeNoteMode = 'EDIT';
  }

}
